import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import '@fortawesome/fontawesome-free/css/all.min.css';
import { getAllmobileApk } from "../Apis/mobileApis/mobileApi";
import { InlineLoader, TableLoader } from "../Common/ShimmerLoader";
import isGHMC from "../Common/helper/helpar";
const getToken = () => {
  return localStorage.getItem("token");
};

const MobileAPKs = () => {
  const [apkData, setApkData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [downloading, setDownloading] = useState({});
  const isProd = isGHMC();
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await getAllmobileApk();
        setApkData(response.data);
        console.log(response.data, "response dataaaaa");
      } catch (error) {
        console.error("Error fetching APK data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleDownload = async (downloadUrl, fileName, apkId) => {
    try {
      setDownloading((prev) => ({ ...prev, [apkId]: true }));
      const token = getToken();
      const response = await fetch(downloadUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      setDownloading((prev) => ({ ...prev, [apkId]: false }));
    }
  };

  return (
    <>
      <style>
        {`
                body {
                    background-color: #f8cccd;
                }
                .bg_col {
                    background-color: #ec1117;
                    padding: 10px 20px;
                }
                .text_st {
                    font-size: 35px;
                    font-weight: 800;
                    color: #FFF;
                }
                .bg_1 {
                    background-color: #ffffff;
                    padding: 25px;
                    border-radius: 10px;
                }
                .btn-success {
                    margin-top: 1rem;
                }
                .Titleof_title-ghmc {
                    margin-top: 1rem;
                    font-weight: 600;
                    font-size: 15px;
                    margin-bottom: 0;
                    color: #043555;
                }
                    .Titleof_title-swm {
                    margin-top: 1rem;
                    font-weight: 600;
                    font-size: 15px;
                    margin-bottom: 0;
                    color: #ec1117;
                    white-space: normal; 
                    word-wrap: break-word; 
                    overflow-wrap: break-word; 
                    max-width: 100%; 
                }
                .Titleof_app {
                    font-size: 14px;
                    font-weight: 500;
                    margin-top: 0;
                    color: #555656;
                }
                .btn-success { 
                    color: #fff;
                    background-color: #453c3d;
                    border-color: #453c3d;
                }
                .btn-success:hover, .btn-success:active {
                    color: #fff;
                    background-color: #ec1117;
                    border-color: #ec1117;
                }
                .btn-success a {
                    text-decoration: none;
                    color: #FFF;
                }
                .Titleof_app span {
                    font-size: 13px;
                }
                .mobile_apps .card {
                    border: 0px;
                    width: 100%;
                }
                @media only screen and (max-width: 600px) {
                    .d-flex {
                        flex-direction: column;
                    }
                    .text_st {
                        font-size: 26px;
                    }
                    .mt-5 {
                        margin-top: 0px !important;
                    }
                }
                `}
      </style>

      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header mb-0">
              <h3>Mobile APK's</h3>
            </div>
            <div className="mobile_apps">
              {isLoading ? (
                <TableLoader height={300} columns={4} />
              ) : (
              <div className="row d-flex align-items-stretch g-3">
                {apkData.map((apk) => (
                  <div key={apk.title} className="col-md-3 d-flex">
                    <div className="card ">
                      <div className="card-body ">
                        <div>
                          <img
                            src="https://egovindia.in/cfcms/public/dashboard/images/apk_download.svg"
                            width={80}
                            alt={apk.title}
                          />
                        </div>
                        <div
                          className={`btn ${
                            isProd ? "Titleof_title-ghmc" : "Titleof_title-swm"
                          }`}
                        >
                          {apk.appName}
                        </div>
                        <div className="Titleof_app">{apk.appVersion}</div>
                        <a
                          className="btn btn-success"
                          // onClick={() =>
                          //   handleDownload(
                          //     apk.downloadUrl,
                          //     apk.fileName,
                          //     apk.id
                          //   )
                          // }
                          target="_blank"
                          href={apk.downloadUrl}
                          // disabled={downloading[apk.id]}
                        >
                          {downloading[apk.id] ? "Downloading..." : "Download"}{" "}
                          <i className="fa-solid fa-download" />
                        </a>
                        {downloading[apk.id] && <InlineLoader />}{" "}
                        {/* Show loader when downloading */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileAPKs;
